import { render, staticRenderFns } from "./ButtonNewRegisterComponent.vue?vue&type=template&id=01ba95fb"
import script from "./ButtonNewRegisterComponent.vue?vue&type=script&lang=js"
export * from "./ButtonNewRegisterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports